<template>
  <div class="station-search-row" @click.prevent="$emit('click', $event)">
    <i :class="['far', icon]"></i>
    <span class="title">{{title}}</span>
    <div class="row content">
      <div class="labels-area">
        <slot name="labels" />
      </div>

      <slot name="notes" />
    </div>

  </div>
</template>

<style lang="scss" scoped>
.station-search-row {
  cursor: pointer;
  height: 64px;
  font-size: 13px;
  padding: 4px;
  
  margin: 10px 6px;
  border-left: 4px solid #2FB2E6;
  background-color: #303030;
}
.station-search-row:hover {
  background-color: #404040;
}
.station-search-row > i {
  font-size: 20px;
}
.station-search-row > .content {
  margin-top: 2px;
  position: relative;
}
.station-search-row > .content .labels-area {
  position: absolute;
  bottom: 0px;
  right: 15px;
  text-align: right;
}
.station-search-row > .content .labels-area > span {
  margin-left: 4px;
}

.station-search-row .title {
  padding-left: 8px;
  font-size: 20px;
}
</style>


<script>
export default {
  name: 'StationSearchRow',
  props: {
    title: String,
    icon: String
  }
}
</script>